<template>
  <v-container
    fluid
  >
    <v-row
      no-gutters
    >
      <v-col
        class="mx-0"
      >
        <div class="d-flex flex-wrap align-center">
          <div class="d-flex align-center comparisons-range">
            <ComparisonRange
              :from="userBaseComparisons.date_from"
              :to="userBaseComparisons.date_to"
              :limit-calendar-months-count="12"
              :disable-dates-in-future-months="true"
              @update="updateComparisonRange">
            </ComparisonRange>
          </div>
          <div class="d-flex spacer"></div>
          <div class="d-flex align-center">
            <div class="d-inline-flex align-center white--text ">
              <div class="d-block">{{ userBaseComparisons.store_name }}</div>
            </div>
            <ModalSingleSelect
              title="店舗選択"
              icon="storefront-outline"
              :lists="companyStores"
              :id="userBaseComparisons.store_id"
              label-field="store_name"
              @select="selectStore"
            />
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row
      class="d-flex">
      <v-col
        cols="12"
        sm="4"
        md="4"
        lg="3"
        xl="2"
      >
        <!-- 売上(税込) -->
        <StatusFrame
          class="fill-height summary-card"
          :status="sales.frame_status"
          :to="{name: 'comparison.graph'}"
        >
          <v-row
            align="center"
            justify="center"
            no-gutters
            class="fill-height"
          >
            <v-col
              class="text-center"
            >
              <SummarySingle
                title="売上(税込)"
                unit-title="万円"
                :value-self="sales.self"
                :value-all="sales.all"
                :value-high="sales.high"
                :value-low="sales.low"
                :use-decimal-point="true"
              />
            </v-col>
          </v-row>
        </StatusFrame>
        <!-- ./売上(税込) -->
      </v-col>
      <v-col
        cols="12"
        sm="4"
        md="4"
        lg="3"
        xl="2"
      >
        <!-- 客数 -->
        <StatusFrame
          class="fill-height summary-card"
          :status="customer.frame_status"
          :to="{name: 'comparison.graph', hash: '#customer'}"
        >
          <v-row
            align="center"
            justify="center"
            no-gutters
            class="fill-height"
          >
            <v-col
            class="text-center"
            >
             <SummarySingle
                title="客数"
                unit-title="人"
                :value-self="customer.self"
                :value-all="customer.all"
                :value-high="customer.high"
                :value-low="customer.low"
                :use-decimal-point="false"
              />
            </v-col>
          </v-row>
        </StatusFrame>
        <!-- ./客数 -->
      </v-col>
      <v-col
        cols="12"
        sm="4"
        md="4"
        lg="3"
        xl="2"
      >
        <!-- 客単価 (税込)-->
        <StatusFrame
          class="fill-height summary-card"
          :status="unit_price.frame_status"
          :to="{name: 'comparison.graph', hash: '#unit_price'}">
          <v-row
            align="center"
            justify="center"
            no-gutters
            class="fill-height"
          >
            <v-col
            class="text-center"
            >
              <SummarySingle
                title="客単価(税込)"
                unit-title="円"
                :value-self="unit_price.self"
                :value-all="unit_price.all"
                :value-high="unit_price.high"
                :value-low="unit_price.low"
                :use-decimal-point="false"
                />
            </v-col>
          </v-row>
        </StatusFrame>
        <!-- ./客単価(税込) -->
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div
          class="text-h6"
        >
          収益力
          <span class="text-caption">座席数や価格などを見直す際の参考にします。</span>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="4"
        md="4"
        lg="3"
        xl="2"
      >
        <!-- 回転数/日 -->
        <StatusFrame
          class="fill-height summary-card"
          :status="rotation.frame_status"
          :to="{name: 'comparison.graph', hash: '#rotation'}"
        >
          <v-row
            align="center"
            justify="center"
            no-gutters
            class="fill-height"
          >
            <v-col
            class="text-center"
            >
              <SummarySingle
                title="回転数/日"
                unit-title="回"
                :value-self="rotation.self"
                :value-all="rotation.all"
                :value-high="rotation.high"
                :value-low="rotation.low"
                :use-decimal-point="true"
              />
            </v-col>
          </v-row>
        </StatusFrame>
        <!-- ./回転数/日 -->
      </v-col>
      <v-col
        cols="12"
        sm="4"
        md="4"
        lg="3"
        xl="2"
      >
        <!-- 平均オーダー数 -->
        <StatusFrame
          class="fill-height summary-card"
          :status="order_count.frame_status"
          :to="{name: 'comparison.graph', hash: '#order_count'}">
          <v-row
            align="center"
            justify="center"
            no-gutters
            class="fill-height"
          >
            <v-col
            class="text-center"
            >
              <SummarySingle
                title="平均オーダー数"
                unit-title="回"
                :value-self="order_count.self"
                :value-all="order_count.all"
                :value-high="order_count.high"
                :value-low="order_count.low"
                :use-decimal-point="true"
              />
            </v-col>
          </v-row>
        </StatusFrame>
        <!-- ./平均オーダー数 -->
      </v-col>
      <v-col
        cols="12"
        sm="4"
        md="4"
        lg="3"
        xl="2"
      >
        <!-- 平均滞在時間 -->
        <StatusFrame
          class="fill-height summary-card"
          :status="staying_time.frame_status"
        >
          <v-row
            align="center"
            justify="center"
            no-gutters
            class="fill-height"
          >
            <v-col
            class="text-center"
            >
              <SummarySingle
                title="平均滞在時間"
                unit-title="分"
                :value-self="staying_time.self"
                :use-decimal-point="true"
              />
            </v-col>
          </v-row>
        </StatusFrame>
        <!-- ./平均滞在時間 -->
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div
          class="text-h6"
        >
          利便性
          <span class="text-caption">商品以外の観点で付加価値を検討します。</span>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="4"
        md="4"
        lg="3"
        xl="2"
      >
        <!-- テイクアウト比率 -->
        <StatusFrame
          class="fill-height summary-card"
          :status="0"
          :to="{name: 'comparison.graph', hash: '#takeout'}">
          <v-row
            align="center"
            justify="center"
            no-gutters
            class="fill-height"
          >
            <v-col
            class="text-center"
            >
              <SummaryMultiple
                title="テイクアウト比率"
                :values="takeout"
              />
            </v-col>
          </v-row>
        </StatusFrame>
        <!-- ./テイクアウト比率 -->
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="5"
        lg="4"
        xl="3"
      >
        <!-- 支払い種別比率 -->
        <StatusFrame
          class="fill-height summary-card"
          :status="0"
          :to="{name: 'comparison.graph', hash: '#payment'}">
          <v-row
            align="center"
            justify="center"
            no-gutters
            class="fill-height"
          >
            <v-col
            class="text-center"
            >
              <SummaryMultiple
                title="支払い種別比率"
                :values="payment"
              />
            </v-col>
          </v-row>
        </StatusFrame>
        <!-- ./支払い種別比率 -->
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div
          class="text-h6"
        >
          マーケティング
          <span class="text-caption">お客様の潜在的なニーズを把握し、施策に活かします。</span>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="4"
        md="4"
        lg="3"
        xl="2"
      >
        <!-- 男女比率 -->
        <StatusFrame
          class="fill-height summary-card"
          :status="0"
          :to="{name: 'comparison.graph', hash: '#gender'}">

            <v-row
              align="center"
              justify="center"
              no-gutters
              class="fill-height"
            >
              <v-col
              class="text-center"
              >
                <SummaryMultiple
                  title="男女比率"
                  :values="gender"
                />
              </v-col>
            </v-row>

        </StatusFrame>
        <!-- ./支払い種別比率 -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SummarySingle from './components/SummarySingle'
import SummaryMultiple from './components/SummaryMultiple'
import StatusFrame from '@/views/components/utility/StatusFrame'
import ComparisonRange from '@/views/components/utility/DatePickerRange'
import ModalSingleSelect from '@//views/components/utility/ModalSingleSelect'
import {
  checkComparison,
  checkDeadline,
  clearData,
  DATA_TYPES, SAVE_STORE_GRAPH,
  SAVE_STORE_SUMMARY,
  saveToStore,
  searchStore,
  sendGetParallelApi
} from "../../../util";

export default {
  name: 'ComparisonSummary',
  components: {
    StatusFrame,
    ComparisonRange,
    SummarySingle,
    SummaryMultiple,
    ModalSingleSelect,
  },
  data () {
    return {
      now: null,
      userBaseComparisons: {
        store_id: null,
        store_name: null,
        date_from: '',
        date_to: '',
        industry_id: null,
        corporation_estimate_sales: null,
        store_estimate_sales: null,
        seat_num: null,
      },
      companyStores: [],
      sales: {
        self: null,
        all: null,
        high: null,
        low: null,
        frame_status: 0,
      },
      customer: {
        self: null,
        all: null,
        high: null,
        low: null,
        frame_status: 0,
      },
      unit_price: {
        self: null,
        all: null,
        high: null,
        low: null,
        frame_status: 0,
      },
      rotation: {
        self: null,
        all: null,
        high: null,
        low: null,
        frame_status: 0,
      },
      order_count: {
        self: null,
        all: null,
        high: null,
        low: null,
        frame_status: 0,
      },
      staying_time: {
        self: null,
        frame_status: 0,
      },
      takeout: [],
      gender: [],
      payment: []
    }
  },
  async beforeRouteEnter(to, from, next) {
    await checkComparison(function(result) {
      if (result) {
        next()
      } else {
        next('/comparison/base')
      }
    });
  },
  mounted() {
    this.initialize()
  },
  methods: {
    initialize () {
      this.getBaseApi()
    },
    getUserBaseComparisons (response) {
      // APIで比較基準設定を取得する
      if (this.checkResponse(response)) {
        let data = response.data.data;
        this.userBaseComparisons.store_id = data.store_id
        this.userBaseComparisons.store_name = data.store_name
        this.userBaseComparisons.industry_id = data.industry_id
        this.userBaseComparisons.corporation_estimate_sales = data.corporation_estimate_sales
        this.userBaseComparisons.store_estimate_sales = data.store_estimate_sales
        this.userBaseComparisons.seat_num = data.seat_num
        let firstDate = '';
        let lastDate = '';
        // 日付のデフォルトを設定
        let now = new Date();
        let yearMonth = now.getFullYear() + '-' + ('00' + (now.getMonth() +1)).slice(-2) + '-'
        // 月初
        now.setDate(1)
        firstDate = yearMonth + ('00' + now.getDate()).slice(-2)
        // 月末
        now.setMonth(now.getMonth() + 1);
        now.setDate(0);
        lastDate = yearMonth + ('00' + now.getDate()).slice(-2)
        this.userBaseComparisons.date_from = firstDate
        this.userBaseComparisons.date_to = lastDate
        // 比較基準をstoreに登録
        this.$store.dispatch('comparison/save', this.userBaseComparisons);
        this.$store.dispatch('comparison/setIsComparisonStatus', true)
        // 初期表示で比較基準の取得後、サマリ取得
        this.getSummary()
      } else {
        this.$store.dispatch('comparison/setIsComparisonStatus', false)
        // 比較基準が取得できない場合は、比較基準の設定ページへ
        this.$router.push('/comparison/base')
      }
    },
    getCompanyStores (response) {
      if (this.checkResponse(response)) {
        this.companyStores = response.data.data;
      }
    },
    updateComparisonRange (evt) {
      // カレンダーで期間が変更されたので、プロパティ書き換え
      this.userBaseComparisons.date_from = evt.from
      this.userBaseComparisons.date_to = evt.to

      // 指定範囲が変更されたので、再度APIをコールし表示データの再取得を行う
      // or
      // storeに書き込んで、再遷移？
      // 比較基準をstoreに登録
      this.$store.dispatch('comparison/save', this.userBaseComparisons);
      this.$store.dispatch('comparison/setChangeStatus', true);
      this.getSummary();
    },
    selectStore (choice) {
      // 店舗リストで店舗が変更されたので、プロパティ書き換え
      this.userBaseComparisons.store_id = choice.id
      this.userBaseComparisons.store_name = choice.store_name
      // 指定店舗が変更されたので、再度APIをコールし表示データの再取得を行う
      // or
      // storeに書き込んで、再遷移？
      // 比較基準をstoreに登録
      this.$store.dispatch('comparison/save', this.userBaseComparisons);
      this.$store.dispatch('comparison/setChangeStatus', true);
      this.getSummary();
    },
    getBaseApi() {
      let apis = [
        // url : callback
        {url: '/target', params: this.userBaseComparisons, callback: this.getCompanyStores},
      ];
      if (this.$store.getters["comparison/saveStatus"]) {
        // 比較基準が保存されていたら設定する
        this.userBaseComparisons.date_from = this.$store.getters["comparison/date_from"]
        this.userBaseComparisons.date_to = this.$store.getters["comparison/date_to"]
        this.userBaseComparisons.store_id = this.$store.getters["comparison/store_id"]
        this.userBaseComparisons.store_name = this.$store.getters["comparison/store_name"]
        this.userBaseComparisons.seat_num = this.$store.getters["comparison/seat_num"]
        this.userBaseComparisons.industry_id = this.$store.getters["comparison/industry_id"]
        // サマリ/グラフ間を移動する前に、期間、店舗を変更した時
        if (this.$store.getters["comparison/changeStatus"]) {
          this.getSummary()
        } else {
          let filter = {
            from: this.userBaseComparisons.date_from,
            to: this.userBaseComparisons.date_to,
            store_id: this.userBaseComparisons.store_id,
            type: DATA_TYPES.SALES,
          }
          checkDeadline(SAVE_STORE_SUMMARY,filter,this.checkDate)
        }
        this.$store.dispatch('comparison/setChangeStatus', false);
      } else {
        apis.push({url:  '/comparison', params: this.userBaseComparisons, callback: this.getUserBaseComparisons})
      }
      sendGetParallelApi(apis)
    },
    getSummary() {
      const apis = [
        // url : callback
        {url: '/summary/sales', params: this.userBaseComparisons, callback : this.setSalesData},
        {url: '/summary/customerCount', params: this.userBaseComparisons, callback : this.setCustomer},
        {url: '/summary/customerUnitPrice', params: this.userBaseComparisons, callback : this.setUnitPrice},
        {url: '/summary/customerRotation', params: this.userBaseComparisons, callback : this.setRotation},
        {url: '/summary/orderAverage', params: this.userBaseComparisons, callback : this.setOrderCount},
        {url: '/summary/stayAverage', params: this.userBaseComparisons, callback : this.setStayingTime},
        {url: '/summary/takeoutRate', params: this.userBaseComparisons, callback : this.setTakeoutRate},
        {url: '/summary/paymentTypeRate', params: this.userBaseComparisons, callback : this.setPayment},
        {url: '/summary/genderRate', params: this.userBaseComparisons, callback : this.setGender},
      ];
      sendGetParallelApi(apis);
    },
    setSalesData(response) {
      if (this.checkResponse(response)) {
        const data = response.data.data;
        const {display = null,value = null} = {...data}
        const raw = (value !== null) ? [value] : []
        const series = (display !== null) ? [display] : []
        const frame_status = this.expandHeaderData(data)

        this.setSummaryData(this.sales, data);
        let saveData = this.setIndexDBData(DATA_TYPES.SALES, series, raw, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_SUMMARY, saveData)
      } else {
        // TODO エラー処理？
      }
    },
    setCustomer(response) {
      if (this.checkResponse(response)) {
        const data = response.data.data;
        const {display = null,value = null} = {...data}
        const raw = (value !== null) ? [value] : []
        const series = (display !== null) ? [display] : []
        const frame_status = this.expandHeaderData(data)

        this.setSummaryData(this.customer, data);
        let saveData = this.setIndexDBData(DATA_TYPES.CUSTOMER, series, raw, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_SUMMARY, saveData)
      }
    },
    setUnitPrice(response) {
      if (this.checkResponse(response)) {
        const data = response.data.data;
        const {display = null,value = null} = {...data}
        const raw = (value !== null) ? [value] : []
        const series = (display !== null) ? [display] : []
        const frame_status = this.expandHeaderData(data)

        this.setSummaryData(this.unit_price, data);
        let saveData = this.setIndexDBData(DATA_TYPES.UNIT_PRICE, series, raw, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_SUMMARY, saveData)
      }
    },
    setRotation(response) {
      if (this.checkResponse(response)) {
        const data = response.data.data;
        const {display = null,value = null} = {...data}
        const raw = (value !== null) ? [value] : []
        const series = (display !== null) ? [display] : []
        const frame_status = this.expandHeaderData(data)

        this.setSummaryData(this.rotation, data);
        let saveData = this.setIndexDBData(DATA_TYPES.ROTATION, series, raw, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_SUMMARY, saveData)
      }
    },
    setOrderCount(response) {
      if (this.checkResponse(response)) {
        const data = response.data.data;
        const {display = null,value = null} = {...data}
        const raw = (value !== null) ? [value] : []
        const series = (display !== null) ? [display] : []
        const frame_status = this.expandHeaderData(data)

        this.setSummaryData(this.order_count, data);
        let saveData = this.setIndexDBData(DATA_TYPES.ORDER, series, raw, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_SUMMARY, saveData)
      }
    },
    setStayingTime(response) {
      if (this.checkResponse(response)) {
        const data = response.data.data;
        const {display = null,value = null} = {...data}
        const raw = (value !== null) ? [value] : []
        const series = (display !== null) ? [display] : []
        const frame_status = this.expandHeaderData(data)
        const {self = null} = this.expandDetailData(display)

        this.staying_time.self = self
        let saveData = this.setIndexDBData(DATA_TYPES.STAY, series, raw, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_SUMMARY, saveData)
      }
    },
    setTakeoutRate(response) {
      if (this.checkResponse(response)) {
        const data = response.data.data;
        const {display = null,value = null} = {...data}
        const raw = (value !== null) ? [value] : []
        const frame_status = this.expandHeaderData(data)

        this.takeout = display
        let saveData = this.setIndexDBData(DATA_TYPES.TAKEOUT, display, raw, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_SUMMARY, saveData)
      }
    },
    setPayment(response) {
      if (this.checkResponse(response)) {
        const data = response.data.data;
        const {display = null,value = null} = {...data}
        const raw = (value !== null) ? [value] : []
        const frame_status = this.expandHeaderData(data)

        this.payment = display
        let saveData = this.setIndexDBData(DATA_TYPES.PAYMENT, display, raw, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_SUMMARY, saveData)
      }
    },
    setGender(response) {
      if (this.checkResponse(response)) {
        const data = response.data.data;
        const {display = null,value = null} = {...data}
        const raw = (value !== null) ? [value] : []
        const frame_status = this.expandHeaderData(data)

        this.gender = display
        let saveData = this.setIndexDBData(DATA_TYPES.GENDER, display, raw, frame_status, this.userBaseComparisons);
        saveToStore(SAVE_STORE_SUMMARY, saveData)
      }
    },
    /**
     * 多店舗と比較する項目を設定する共通関数
     * @param displayData
     * @param resultData
     */
    setSummaryData(displayData, resultData) {
      const {display = {}} = {...resultData}
      const frame_status = this.expandHeaderData(resultData)
      const {self, all, high, low} = this.expandDetailData(display)

      displayData.self = self
      displayData.all = all
      displayData.high = high
      displayData.low = low
      displayData.frame_status = frame_status
    },
    /**
     * 非同期通信の結果を返す
     * @param response
     * @returns {boolean}
     */
    checkResponse(response) {
      const result = response.data?.result || 0;
      const data = response.data?.data || null;
      return result === true && data !== null;
    },
    setIndexDBData (type, displayData, values, frame_status, comparison) {
      return {
        from: comparison.date_from,
        to: comparison.date_to,
        store_id: comparison.store_id,
        type: type,
        details: displayData,
        raw: values,
        frame_status: frame_status,
        timestamp: new Date().getTime()
      }
    },
    checkDate(statuses) {
      if (statuses.status) {
        if(statuses.deadline) {
          clearData(SAVE_STORE_SUMMARY)
          clearData(SAVE_STORE_GRAPH)
        }
        this.searchIndexedDB()
      } else {
        this.getSummary()
      }
    },
    searchIndexedDB() {
      const searchList = [
        {type: DATA_TYPES.SALES, base: this.userBaseComparisons,callback: this.setRetentionSales},
        {type: DATA_TYPES.CUSTOMER, base: this.userBaseComparisons,callback: this.setRetentionCustomer},
        {type: DATA_TYPES.UNIT_PRICE, base: this.userBaseComparisons,callback: this.setRetentionUnitPrice},
        {type: DATA_TYPES.ROTATION, base: this.userBaseComparisons,callback: this.setRetentionRotation},
        {type: DATA_TYPES.ORDER, base: this.userBaseComparisons,callback: this.setRetentionOrder},
        {type: DATA_TYPES.STAY, base: this.userBaseComparisons,callback: this.setRetentionStay},
        {type: DATA_TYPES.TAKEOUT, base: this.userBaseComparisons,callback: this.setRetentionTakeout},
        {type: DATA_TYPES.PAYMENT, base: this.userBaseComparisons,callback: this.setRetentionPayment},
        {type: DATA_TYPES.GENDER, base: this.userBaseComparisons,callback: this.setRetentionGender}
      ]
      searchList.forEach(function(obj) {
        searchStore(SAVE_STORE_SUMMARY,{
          from: obj.base.date_from,
          to: obj.base.date_to,
          store_id: obj.base.store_id,
          type: obj.type,
        },obj.callback)
      });
    },
    setRetentionSales(detail) {
      if(detail) {
        const data = (Array.isArray(detail.data) && detail.data.length > 0) ? detail.data[0] : {}
        const header = detail.header[0];
        this.setRetentionData(this.sales, header, data);
      }
    },
    setRetentionCustomer(detail) {
      if(detail) {
        const data = (Array.isArray(detail.data) && detail.data.length > 0) ? detail.data[0] : {}
        const header = detail.header[0]
        this.setRetentionData(this.customer, header, data)
      }
    },
    setRetentionUnitPrice(detail) {
      if(detail) {
        const data = (Array.isArray(detail.data) && detail.data.length > 0) ? detail.data[0] : {}
        const header = detail.header[0]
        this.setRetentionData(this.unit_price, header, data)
      }
    },
    setRetentionRotation(detail) {
      if(detail) {
        const data = (Array.isArray(detail.data) && detail.data.length > 0) ? detail.data[0] : {}
        const header = detail.header[0]
        this.setRetentionData(this.rotation, header, data)
      }
    },
    setRetentionOrder(detail) {
      if(detail) {
        const data = (Array.isArray(detail.data) && detail.data.length > 0) ? detail.data[0] : {}
        const header = detail.header[0]
        this.setRetentionData(this.order_count, header, data)
      }
    },
    setRetentionStay(detail) {
      if(detail) {
        const data = (Array.isArray(detail.data) && detail.data.length > 0) ? detail.data[0] : {}
        const header = detail.header[0]
        this.setRetentionData(this.staying_time, header, data)
      }
    },
    setRetentionTakeout(detail) {
      if(detail) {
        const data = (Array.isArray(detail.data) && detail.data.length > 0) ? detail.data : []
        this.takeout = data
      }
    },
    setRetentionPayment(detail) {
      if(detail) {
        const data = (Array.isArray(detail.data) && detail.data.length > 0) ? detail.data : []
        this.payment = data
      }
    },
    setRetentionGender(detail) {
      if(detail) {
        const data = (Array.isArray(detail.data) && detail.data.length > 0) ? detail.data : []
        this.gender = data
      }
    },
    setRetentionData (target, header, detail) {
      const frame_status = this.expandHeaderData(header)
      const {self, all, high, low} = this.expandDetailData(detail)
      target.self = self
      target.all = all
      target.high = high
      target.low = low
      target.frame_status = frame_status
    },
    /**
     * ヘッダデータ展開
    */
    expandHeaderData (header) {
      const {frame_status = 0} = {...header}
      return frame_status
    },
    /**
     * 明細データ展開
     */
    expandDetailData (details) {
      const {self = null, all = null, high = null, low = null} = {...details}
      return {self, all, high, low, }
    },
  },
}
</script>
<style lang="scss" scoped>
  .container {
    background-image: url(~@/assets/images/bg_comparison.svg);
    background-size: contain;
  }
  @media (min-width: 600px) {
    .container {
      background-position: 0px -0px;
    }
  }
  @media (min-width: 960px) {
    .container {
      background-position: 0px -35px;
    }
  }
  @media (min-width: 1264px) {
    .container {
      background-position: 0px -160px;
    }
  }
  @media (min-width: 1904px) {
    .container {
      background-position: 0px -300px;
    }
  }
</style>
<style lang="scss">
  .summary-card {
    min-height: 200px;
  }
</style>
